/**
 * Confirm-dialog choices that must survive the hop to the FarmUWQuestionsModal. A farm endorsement
 * that needs UW review is confirmed from that modal, not from the preview dialog where the
 * checkboxes were ticked, so policy.jsx captures them on "Continue to UW review" and adds them back
 * to the modal's confirm values.
 */
export const captureUWReviewConfirmChoices = (previewDialogValues) => ({
  // #37246
  suppressCommunications: Boolean(previewDialogValues?.suppressCommunications),
  // #37977
  bypassMicroBiltVerification: Boolean(previewDialogValues?.bypassMicroBiltVerification)
});

export const withUWReviewConfirmChoices = (uwQuestionsValues, carriedChoices) => ({
  ...uwQuestionsValues,
  ...carriedChoices
});
